import { RouteObject } from 'react-router-dom';
import { FounderRouteProtection } from '../loaders/FounderFolderLoaders/FounderRouteProtection';
import { CatalogRouteProtection } from '../loaders/FounderFolderLoaders/CatalogRouteProtection';
import CatalogLandingPage from '../pages/Admin/Catalog/CatalogLandingPage';
import CatalogMobileLandingPage from '../pages/Admin/Catalog/CatalogMobileLandingPage';
import CardListPage from '../pages/Admin/Catalog/Cards/CardListPage';
import ExpansionListPage from '../pages/Admin/Catalog/Expansions/ExpansionListPage';
import PackListPage from '../pages/Admin/Catalog/Packs/PackListPage';
import DashboardPage from '../pages/Admin/Catalog/DashboardPage';
import AppSettingsPage from '../pages/Admin/Catalog/AppSettingsPage';
import QuizListPage from '../pages/Admin/Catalog/Quiz/QuizListPage';

export const catalogRoutes: RouteObject = {
  path: 'catalog',
  children: [
    { index: true,     element: <CatalogLandingPage />,       loader: CatalogRouteProtection },
    { path: 'mobile',  element: <CatalogMobileLandingPage />, loader: CatalogRouteProtection },
    { path: 'dashboard', element: <DashboardPage />,          loader: CatalogRouteProtection },
    { path: 'cards',   element: <CardListPage />,             loader: FounderRouteProtection },
    { path: 'expansions', element: <ExpansionListPage />,     loader: FounderRouteProtection },
    { path: 'packs',   element: <PackListPage />,             loader: FounderRouteProtection },
    { path: 'settings', element: <AppSettingsPage />,         loader: FounderRouteProtection },
    { path: 'quiz',    element: <QuizListPage />,             loader: CatalogRouteProtection },
  ]
};
